module.exports = __webpack_public_path__ + "static/media/bnb.5bfa501b.svg";